import React, { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Card } from '../Card';
import { Text } from '../Text';
import { ENTER_KEY, ENTER_KEYCODE, SPACE_KEYCODE } from '../Utils/constant';
import { throttle } from '../Utils/helper';
import styles from '@dtsl/css-dropzone/dist/index.module.css';
import Download from '@dtsl/icons/dist/icons/react/Download';
function Dropzone(props) {
  const {
    label,
    display,
    multiple,
    subLabel,
    className,
    dataTestId,
    description,
    dragOverLabel,
    handleAddFiles,
    acceptedFileTypes
  } = props;
  const fileInputRef = useRef(null);
  const [isDragOver, setIsDragOver] = useState(false);
  const dropzoneCardClass = classNames({
    [styles['sib-dropzone']]: true,
    [styles[`sib-dropzone--${display}`]]: display && display !== 'wrapped',
    [styles['drag-over']]: isDragOver,
    [className]: !!className
  });
  const dropzoneInformationClass = classNames({
    [styles['sib-dropzone__information']]: true,
    [styles[`sib-dropzone__information-${display}`]]: display && display !== 'wrapped'
  });
  const handleDragOver = e => {
    e.preventDefault();
    setIsDragOver(true);
  };
  const handleDragLeave = e => {
    e.preventDefault();
    setIsDragOver(false);
  };
  const handleDrop = e => {
    var _e$dataTransfer;
    e.preventDefault();
    const files = Array.from((_e$dataTransfer = e.dataTransfer) === null || _e$dataTransfer === void 0 ? void 0 : _e$dataTransfer.files);
    handleAddFiles(e, files);
    setIsDragOver(false);
  };
  const handleKeyUp = e => {
    e.preventDefault();
    if (e.keyCode === ENTER_KEYCODE || e.key === ENTER_KEY || e.keyCode === SPACE_KEYCODE) {
      var _fileInputRef$current;
      (_fileInputRef$current = fileInputRef.current) === null || _fileInputRef$current === void 0 ? void 0 : _fileInputRef$current.click();
    }
  };
  const handleFileChange = e => {
    var _e$target;
    e.preventDefault();
    const files = Array.from((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.files);
    handleAddFiles(e, files);
  };
  const {
    execThrottle: handleThrottledDragOver,
    cancelThrottle
  } = throttle(handleDragOver, 2000);
  useEffect(() => {
    return () => cancelThrottle();
  }, []);
  return /*#__PURE__*/React.createElement(Card, {
    className: dropzoneCardClass,
    customCard: true,
    variant: "clickable",
    dataTestId: dataTestId,
    onKeyUp: handleKeyUp
  }, /*#__PURE__*/React.createElement(Card.Content, {
    style: {
      padding: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: dropzoneInformationClass
  }, /*#__PURE__*/React.createElement("span", {
    className: styles['sib-dropzone__information--upload-icon']
  }, /*#__PURE__*/React.createElement(Download, null)), /*#__PURE__*/React.createElement("div", {
    className: styles['sib-dropzone__information--label-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['sib-dropzone__information--labels']
  }, /*#__PURE__*/React.createElement("span", {
    className: styles['sib-dropzone__information--label-primary']
  }, !isDragOver ? label : dragOverLabel), ' ', !isDragOver ? /*#__PURE__*/React.createElement(Text, {
    className: styles['sib-dropzone__information--label-secondary']
  }, subLabel) : null), /*#__PURE__*/React.createElement(Text, {
    className: styles['sib-dropzone__information--description'],
    size: "md",
    color: "var(--sib-color_content-secondary)"
  }, description))), /*#__PURE__*/React.createElement("input", {
    ref: fileInputRef,
    type: "file",
    className: styles['sib-dropzone__fileInput'],
    accept: acceptedFileTypes === null || acceptedFileTypes === void 0 ? void 0 : acceptedFileTypes.join(','),
    multiple: multiple ? true : false,
    onDragOver: handleThrottledDragOver,
    onDragLeave: handleDragLeave,
    onDrop: handleDrop,
    onChange: handleFileChange
  })));
}
Dropzone.defaultProps = {
  display: 'wrapped',
  label: '',
  dragOverLabel: '',
  subLabel: '',
  description: '',
  acceptedFileTypes: ['.pdf', '.png', '.jpg', '.jpeg', '.gif', '.mp4'],
  handleAddFiles: () => {},
  dataTestId: '',
  multiple: true,
  className: ''
};
Dropzone.propTypes = {
  display: PropTypes.oneOf(['wrapped', 'inline', 'semi-inline']),
  label: PropTypes.string,
  dragOverLabel: PropTypes.string,
  subLabel: PropTypes.string,
  description: PropTypes.string,
  acceptedFileTypes: PropTypes.array,
  multiple: PropTypes.bool,
  dataTestId: PropTypes.string,
  handleAddFiles: PropTypes.func,
  className: PropTypes.string
};
export default Dropzone;